import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { MediaPreviewModule } from '@epicuro-next/ataraxia/media-preview';
import { ModalModule } from '@epicuro-next/ataraxia/modal';
import { NewsfeedApiService } from '@epicuro-next/data/engagement/engagement-api';
import { mapEngagementMediaToLegacy } from '@epicuro-next/data/engagement/engagement-api-utils';
import { NewsfeedItemResponseDto } from '@epicuro-next/data/engagement/engagement-models';
import { decode } from 'html-entities';
import { map } from 'rxjs';

import { WelcomePanelComponentStore } from './welcome-panel.component.store';

@Component({
  selector: 'epc-welcome-modal-panel',
  templateUrl: './welcome-modal-panel.component.html',
  styleUrls: ['./welcome-modal-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ModalModule, IconsModule, MediaPreviewModule],
  providers: [NewsfeedApiService, WelcomePanelComponentStore],
})
export class WelcomeModalPanelComponent implements OnInit {
  private readonly welcomeStore = inject(WelcomePanelComponentStore);
  public readonly videoAttributes = {
    muted: true,
    autoplay: true,
    controls: true,
    disablePlaceholder: true,
  };

  public showModal$ = this.welcomeStore.showModal$;
  public feed$ = this.welcomeStore.feedToShow$;
  public readonly vm$ = this.feed$.pipe(
    map((feed) => {
      const media = feed?.media ?? feed?.references?.[0]?.media;
      return {
        // BS has lists without media
        media: media ? mapEngagementMediaToLegacy(media) : null,
        title: decode(feed?.title),
        description: decode(feed?.references?.[0]?.description ?? ''),
        listId: feed?.references?.[0]?.id,
        listReference: feed?.references?.[0],
      };
    }),
  );

  public ngOnInit() {
    this.welcomeStore.getFeeds();
  }

  public closeModal() {
    this.welcomeStore.toggleModal(false);
  }

  public seeMore(feedReference?: NewsfeedItemResponseDto) {
    if (feedReference) {
      this.welcomeStore.listenUrlClick(feedReference);
    }
  }
}
